import BasicModal from '../../../../components/action-modal';
import { DeleteKBFolderProps } from '../kb.props';

function DeleteKBFolder({ open, type, handleCancelClick, handleDeleteKb }: DeleteKBFolderProps) {
  return (
    <BasicModal
      className="w-[400px]"
      open={open}
      resetData={handleCancelClick}
      confirmButtonText="Delete"
      saveData={handleDeleteKb}
    >
      <span className="font-semibold text-center pb-3">
        {`Are you sure you want to delete the selected ${type}?`}
      </span>
    </BasicModal>
  );
}

export default DeleteKBFolder;
